// clearInputs.js
// Mobile: replace map pick button with clear input button functionality
// Attaches click listeners to buttons with class .input-clear-btn

function attachClearHandlers() {
  const clearButtons = document.querySelectorAll('.input-clear-btn');
  clearButtons.forEach(btn => {
    const targetId = btn.getAttribute('data-clear');
    if (!targetId) return;
    const input = document.getElementById(targetId);
    if (!input) return;
    btn.addEventListener('click', () => {
      input.value = '';
      // Trigger input/change events so any listeners (e.g. route recalculation) can react
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.focus();
    });
  });
}

// Run immediately after DOM is parsed
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', attachClearHandlers);
} else {
  attachClearHandlers();
}

export {}; // mark as module
